module.exports = __webpack_public_path__ + "media/images/homes/pos-twitter-ab6408b6834165f2804107106db7dcb2.png";